import React from 'react';

export const Bank = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 52"
    fill="none"
    {...props}
  >
    <path
      d="M8.66662 32.5002V26.7181M20.2222 32.5002V26.7181M31.7777 32.5002V26.7181M43.3333 32.5002V26.7181M5.19995 39.8669H46.7999V46.8002H5.19995V39.8669ZM5.19995 19.0669V14.4446L25.1452 5.2002L46.7999 14.4446V19.0669H5.19995Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
